// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.arrow-module__arrow___v3p8y svg {
  fill: var(--primary600, #4b286d);
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/lists/activity-list-item/parts/arrow/arrow.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACGE;EACE,gCAAA;AAKJ","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../../../styles/utils';\n\n.arrow {\n  svg {\n    fill: color(primary600);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"arrow": `arrow-module__arrow___v3p8y`
};
export default ___CSS_LOADER_EXPORT___;
